import { prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getAllCampaigns = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'allCampaigns'));
export const getSelectedCampaign = createSelector(getRoot, propOr(null, 'selectedCampaign'));
export const getSelectedCampaignContacts = createSelector(getRoot, propOr(null, 'selectedCampaignContacts'));
